import address from "./address";
import contact from "./contact";
import document from "./document";
import operatingCostAgreement from "./operatingCostAgreement";

const rentalObject = `
    address {
        ${address}
    }
    buildingKind
    buildingType
    centralHeating
    coldRent
    contractDate
    created
    currentRent
    currentRentSince
    floor
    heatedSquareMeters
    heatingCosts
    id
    landlord {
        ${contact}
    }
    modernization
    movedIn
    movedOut
    operatingCostAgreement {
        ${operatingCostAgreement}
    }
    operatingCosts
    ownBathroom
    personsInHousehold
    privateLandlord
    privateRental
    propertyManagement {
        ${contact}
    }
    rentalContract {
        ${document}
    }
    rentalContractId
    rentalContractLimited
    rentalDeposit
    rentalDepositKind
    socialBuilding
    squareMeters
    tenants {
        id
        firstName
        lastName
        birthDate
    }
    totalBuildingSpace
    totalRent
`;

export default rentalObject;
